import tw, { css, styled } from "twin.macro"

export const StyledBodyText = styled("div")(() => [
  tw``,
  css`
    p,
    blockquote,
    .media-asset {
      ${tw`
        // line-length-md
      `}
    }
    .feature {
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      blockquote,
      .media-asset {
        ${tw`
          mx-auto
          max-w-[770px]
        `}
      }
      .caption {
        ${tw`
          py-2 px-4 
          tablet:(px-8)
          font-sans
          text-rpd-gray-8 
          text-xs
          leading-[18px]
          tablet:(leading-[22px] text-sm)
        `}
      }
      .caption p {
        ${tw`
          mb-1.5
          !max-w-none
        `}
      }
    }
    blockquote {
      ${tw`
        my-6
        mb-8
        px-10
        tablet:(my-10 px-16)
      `}
    }
    a {
      ${tw`
        text-blue-500
      `}
    }
    h2 {
      ${tw`
        pt-6
        pb-2.5
        font-sans
        uppercase
      `}
      letter-spacing: 0.04em;
    }
    > h2:first-child {
      ${tw`
        pt-0
      `}
    }
    h3 {
      ${tw`
        font-sans
        font-bold
        pt-6
        pb-2.5
      `}
    }
    h4 {
      ${tw`
        font-sans
        font-bold
        // text-lg
      `}
    }
    h5 {
      ${tw`
        font-sans
        font-bold
        text-md
        // line-length-lg
        
      `}
    }
    p {
      margin-bottom: 1em;
    }

    p strong {
      ${tw`
        font-black
        text-rpd-red
      `}
    }

    > p:last-child,
    > div p:last-child {
      margin-bottom: 0;
    }

    i,
    em {
      letter-spacing: 0.01em;
    }

    ul,
    ol {
      ${tw`
          px-6
          space-y-2
      `}
      ul,
      ol {
        ${tw`
          space-y-0
          px-10
        `}
      }
    }
    ul {
      ${tw`
        list-none
      `}
    }

    ol {
      ${tw`
        list-decimal
      `}
    }
    li ul,
    li ol {
      ${tw`
        my-4
      `}
    }
    ul li {
      text-indent: -20px;
    }
    ul li:before {
      content: "•";
      ${tw`
        pr-2
        text-xl
      `}
    }
    media {
      max-width: none;
    }
    hr {
      ${tw`
        mx-auto
        my-20
        border-rpd-gray-8
        w-96
      `}
    }
    code {
      ${tw`
        rounded
        font-sans
        text-sm
      `}
    }
    pre {
      ${tw`
        mb-6
        w-min
        rounded
        font-sans
        py-2
      `}
    }
    pre code {
      ${tw`
        font-sans
        text-sm
      `}
    }
    .embedCard {
      ${tw`
        no-underline
        text-rpd-gray-9
      `}
    }
  `,
])
